// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'inte... Remove this comment to see the full error message
import Interframe from 'interframe';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'inte... Remove this comment to see the full error message
import { Deferred } from 'interframe/utils/Promise';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'edit... Remove this comment to see the full error message
import * as PostMessageTypes from 'editor-iframe-lib/constants/PostMessageTypes';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'edit... Remove this comment to see the full error message
import { syncIframeState } from 'editor-iframe-lib/redux/actions/syncActions';
import { push } from '../actions/HistoryActions';
import { updateSelectedNavItemPath } from '../actions/TemplateEditorNavigationActions';
import { NAV_ITEMS } from 'knowledge-content-ui/constants/TemplateEditorConstants';
import { POST_MESSAGE_TYPES as KbPostMessageTypes, PREVIEW_SELECTORS } from 'knowledge-content-ui/constants/TemplateEditorPreviewConstants';
import { TEMPLATE_EDITOR_IFRAME_LOADED, TEMPLATE_EDITOR_IFRAME_LOADING_ERROR, TEMPLATE_EDITOR_IFRAME_READY } from '../actions/ActionTypes';
import { getPreviewOrigin } from './previewUtils';
import UsageTracker from '../utils/UsageTracker';
import { SCREENS } from '../constants/TrackingConstants';
import { getTemplateEditorContentPath } from '../routing/utils/internalPaths';
const TRACKING_PREVIEW_SELECTOR_TO_ACTION = {
  [PREVIEW_SELECTORS.HEADER]: 'homepage-area-click-nav',
  [PREVIEW_SELECTORS.SEARCH_SECTION]: 'homepage-area-click-header',
  [PREVIEW_SELECTORS.SEARCH_TITLE]: 'homepage-area-click-header-message',
  [PREVIEW_SELECTORS.INDEX_CATEGORIES_CONTAINER]: 'homepage-area-click-categories',
  [PREVIEW_SELECTORS.INDEX_CATEGORY_PREFIX]: 'homepage-area-click-single-category'
};
class PreviewController {
  constructor() {
    this.setStore = store => {
      this.store = store;
    };
    this.setPreviewDomain = previewDomain => {
      this.previewDomain = previewDomain;
    };
    this.start = targetWindow => {
      this.deferred = new Deferred();
      this.ready = false;
      this.messenger = new Interframe(getPreviewOrigin(this.previewDomain), targetWindow);
      this.unpause();
      return this.deferred.promise;
    };
    this.pause = () => {
      if (this.unsubscribe) {
        this.unsubscribe();
      }
      this.unsubscribe = null;
      this.paused = true;
    };
    this.unpause = () => {
      if (!this.unsubscribe) {
        this.unsubscribe = this.messenger.subscribe(this.receiveMessage).unsubscribe;
      }
      this.paused = false;
    };
    this.receiveMessage = message => {
      switch (message.type) {
        case KbPostMessageTypes.PREVIEW_ELEMENT_CLICKED:
          {
            if (message.navItemPath[0] === NAV_ITEMS.CONTENT) {
              const navItem = message.navItemPath[1];
              this.store.dispatch(push(getTemplateEditorContentPath(navItem)));
            }
            this.store.dispatch(updateSelectedNavItemPath(message.navItemPath, message.categoryId, {
              queryPreviewPage: null
            }));
            const usageTrackingAction = TRACKING_PREVIEW_SELECTOR_TO_ACTION[message.previewSelector];
            if (usageTrackingAction) {
              UsageTracker.track('templateEditorInteraction', {
                screen: SCREENS.TEMPLATE_EDITOR,
                action: usageTrackingAction
              });
            }
            break;
          }
        case PostMessageTypes.IFRAME_ROOT_MOUNTED:
          {
            this.deferred.resolve();
            this.ready = true;
            this.store.dispatch({
              type: TEMPLATE_EDITOR_IFRAME_READY
            });
            break;
          }
        case PostMessageTypes.IFRAME_ROOT_LOADED:
          {
            this.store.dispatch({
              type: TEMPLATE_EDITOR_IFRAME_LOADED
            });
            break;
          }
        case PostMessageTypes.IFRAME_ROOT_LOADING_ERROR:
          {
            this.store.dispatch({
              type: TEMPLATE_EDITOR_IFRAME_LOADING_ERROR
            });
            break;
          }
        default:
          break;
      }
    };
    this.postMessage = (message, type) => {
      if (this.messenger && !this.paused) {
        this.messenger.postMessage(message, type);
      }
    };
    this.syncIframeState = (diff = {}) => {
      // @ts-expect-error ts-migrate(2554) FIXME: Expected 2 arguments, but got 1.
      this.postMessage({
        type: PostMessageTypes.REDUX_ACTION,
        payload: syncIframeState({
          diff
        })
      });
    };
  }
}
export default new PreviewController();